import React from "react";

function DefaultBannerDetails() {
  return (
    <div className="col-sm-5">
      <div className="carousel-caption pt-5">
        <div className="sub-banner-area__text">
          <h4 className="text-center font-weight-bold">Advertise</h4>
          <h5 className="text-center sub-text mb-3">your applications here</h5>
        </div>
      </div>
    </div>
  );
}

export default DefaultBannerDetails;
